/** @module csi/image/ImageColorPicker **/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-style",
	"dijit/form/DropDownButton",
	"csi/widget/SvgColorPalette"
], function(declare,lang,domStyle,DropDownButton,SvgColorPalette) {

	return declare([DropDownButton], {
		/**
		 * Creates the dropdown and add the color palette widget to the dropdown
		 */
		postCreate: function() {
			this.dropDown = new SvgColorPalette({
				"class": "csi-image-color-picker",
				bSupportTransparent: true,
				onChange: lang.hitch(this, this._onChangeColor),
				onShow: function() {
					this.domNode.style.zIndex = 10000
				},
				newColors: [{name: "Dark grey", value: [32,32,32]}]
			});
			
			this.domNode.classList.add("csi-toolbar-btn-backgroundColor");
			this.iconNode.innerText = "format_color_fill";
			this.iconNode.classList.add("csiActionIcon","material-icons","csi-toolbar-btn-icon-backgroundColor");
			
			this.inherited(arguments);
		},
		
		/**
		 * @override
		 * Make sure dropdown is focused to prevent autoclosing of dropdown when image viewer is initiated from popups
		 */
		openDropDown: function() {
			this.inherited(arguments);
			
			this.dropDown.focus();
		},

		/**
		 * Update current color and apply
		 * @param  {Object} value
		 */
		_onChangeColor: function(value) {
			this._updateIcon(value);
			this.onChangeColor(value);
		},

		/**
		 *  Need to translate "none" to background color of toolbar for icon color
		 * @param  {string} value
		 */
		_updateIcon: function(value) {
			domStyle.set(this.iconNode.nextSibling,{
				'background': (value === this.dropDown.TRANSPARENT) ? "#f3f3f3" : (value || "#000000"),
				'outline': (value === this.dropDown.TRANSPARENT) ? "1px solid #bababa" : "none"
			});
		}
	});
});
